import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";

import { ChatsFilter, IReactToMessageDto, IUpdateChatDto } from "../interfaces";

export default {
  // ChatsFilter.page is 0-indexed everywhere in this app's Redux state (matching every other
  // domain), but the backend's chat list endpoint is deliberately 1-indexed (see
  // api/app/shared/schemas/chat.schemas.ts's pageQueryNumber) — translate only at this boundary.
  getChatList: (payload: ChatsFilter) =>
    request(METHODS.GET, API.CHAT.GET_LIST)({ params: { ...payload, page: payload.page + 1 } }),
  getChat: (uuid: string) => request(METHODS.GET, API.CHAT.GET_CHAT(uuid))(),
  getStarters: () => request(METHODS.GET, API.CHAT.GET_STARTERS)(),
  getQuota: () => request(METHODS.GET, API.CHAT.GET_QUOTA)(),
  // The backend registers rename/reaction as PUT (putRoute), not PATCH — matches Procedure's own use of METHODS.PUT.
  updateChat: ({ uuid, title }: IUpdateChatDto) => request(METHODS.PUT, API.CHAT.UPDATE_CHAT(uuid))({ title }),
  deleteChat: (uuid: string) => request(METHODS.DELETE, API.CHAT.DELETE_CHAT(uuid))(),
  reactToMessage: ({ chatUuid, messageUuid, is_liked, feedback, feedback_reason }: IReactToMessageDto) =>
    request(
      METHODS.PUT,
      API.CHAT.UPDATE_MESSAGE(chatUuid, messageUuid),
    )({
      is_liked,
      feedback,
      // Web-compat: the develop api's reaction schema is `.strict()` and only knows is_liked/feedback --
      // sending feedback_reason at all (even null) 400s there. Include it only for a real reason: the
      // new api clears any stored reason itself whenever is_liked is true or null, and a fresh dislike
      // always follows one of those states, so omitting a null reason is safe against both apis.
      ...(feedback_reason != null && { feedback_reason }),
    }),
  // R06 — tells the server to stop generating the answer in progress in this chat.
  stopChat: (chatUuid: string) => request(METHODS.POST, API.CHAT.STOP_CHAT(chatUuid))(),
};
